<template>
  <base-card :class="{'d-none': !elements || elements.length === 0}">
    <base-heading>Products</base-heading>
    <base-list
      :page-size="pageSize"
      :items="elements"
      :count="count"
      :loading="loading"
      :mode="mode"
      :load-more-bottom-threshold="10"
      :show-load-more="false"
      @load-more="loadMore"
      @reached-bottom="loadMore"
    >
      <template #loading>
        <div>LOADING</div>
      </template>
      <template #default="{item}">
        <product-item
          :img="item.display_image || item.image_url"
          :title="item.title || item.product.title || ''"
          :description="item.product.brand.name"
          :editable="false"
          :can-delete="false"
        />
      </template>
      <template #nodata>
        <div>NO DATA</div>
      </template>
    </base-list>
    <div class="products-grid" />
  </base-card>
</template>

<script>
import Listable from '@/components/mixins/listable';

export default {
  name: 'AppointmentProductItems',
  mixins: [Listable],
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    // listable props
    source: {
      type: String,
      default: 'productImage',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 6,
    },
    noMultiRequest: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    appointment() {
      return this.$store.state.appointments.item;
    },
    count() {
      return this.$store.state.appointments.count;
    },
  },
  created() {
    this.$set(this, 'queryParams', {
      appointment: this.$route.params.appointmentId,
    });
  },
};
</script>
<style lang="scss" scoped>
::v-deep .base-list__content>div {
  display: grid;
  grid-column-gap: 2.5625rem;
  grid-row-gap: 4.375rem;
  grid-template-columns: 33% 33% 33%;
  padding: 0 5.625rem;
}
</style>
